import unwrapRef from './unwrapRef';
const defaultSortTypes = {
  date: (a, b, dataKey) => new Date(a[dataKey]) - new Date(b[dataKey]),
  number: (a, b, dataKey) => Number(a[dataKey]) - Number(b[dataKey]),
  stringFast: (a, b, key) => {
    if (a[key] < b[key]) return -1;
    if (a[key] > b[key]) return 1;
    return 0;
  },
  string: (a, b, dataKey) => a[dataKey].localeCompare(b[dataKey], undefined, {
    numeric: true,
    sensitivity: 'base'
  })
};
function sortRows(rows, sortState, columns, customSortTypes, categories) {
  if (!(sortState && sortState.key && sortState.order)) {
    return rows;
  }
  const {
    key,
    order
  } = sortState;
  const column = columns.find(column => column.dataKey === key);
  if (!column) {
    return rows;
  }
  const sortTypes = {
    ...defaultSortTypes,
    ...customSortTypes
  };
  const sortType = column.sortType || 'string';
  const sortFn = typeof sortType === 'function' ? sortType : sortTypes[sortType];
  const sortAndOrderArray = array => {
    let sorted = array.slice().sort((a, b) => sortFn(a, b, key));
    return order === 'asc' ? sorted : sorted.reverse();
  };
  if (categories) {
    let allSortedRows = [];
    categories.map(category => {
      let categoryRows = rows.filter(row => row.category === category.key);
      if (category.subCategories) {
        category.subCategories.map(subCategory => {
          let subCategoryRows = categoryRows.filter(row => row.subCategory === subCategory.key);
          allSortedRows = allSortedRows.concat(sortAndOrderArray(subCategoryRows));
        });
      } else {
        allSortedRows = allSortedRows.concat(sortAndOrderArray(categoryRows));
      }
    });
    return allSortedRows;
  }
  const result = sortAndOrderArray(rows);
  return result;
}
const identity = x => x;
function filterRows(rows, filterState) {
  if (!filterState) {
    return rows;
  }
  const filters = Object.keys(filterState).map(key => filterState[key]).filter(f => unwrapRef(f.isActive)(f.value)).map(f => rows => rows.filter(row => unwrapRef(f.includeRow)(row, f.value)));
  function composeFilters(filters) {
    return filters.filter(f => f && typeof f === 'function').reduce((f, g) => rows => f(g(rows)), identity);
  }
  const result = composeFilters(filters)(rows);
  return result;
}
const escape = str => str.replace(/[\^$\\.*+?()[\]{}|]/g, '\\$&');

// These can be converted to props if they ever need to be configurable
const useMultiKeywordSearch = true;
const multiKeywordSearchSplitCharacter = /[ ,]+/;
function createRowByQueryOnKeysFilter(keys) {
  return (row, query) => {
    const queries = useMultiKeywordSearch ? query.split(multiKeywordSearchSplitCharacter).map(query => query.trim()).filter(query => query !== '') : [query];
    const patterns = queries.map(query => new RegExp(escape(query), 'i'));
    return keys.some(key => patterns.some(pattern => pattern.test(row[key])));
  };
}
function getCurrentPage(filteredRows, paginationState) {
  if (!filteredRows || !paginationState || Object.getOwnPropertyNames(paginationState).length < 2) {
    return {
      rows: filteredRows,
      pageCount: 1
    };
  }
  const {
    pageSize,
    currentPage
  } = paginationState;
  const start = pageSize * currentPage;
  const end = pageSize * (currentPage + 1);
  const rows = filteredRows.slice(start, end);
  const pageCount = Math.ceil(filteredRows.length / pageSize);
  return {
    rows,
    pageCount
  };
}
export { sortRows, filterRows, createRowByQueryOnKeysFilter, getCurrentPage };